var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"completion-graph"},_vm._l((this.reports),function(report,index){return _c('div',{key:index,staticClass:"completion-graph__item"},[_c('CompletionGraphItem',{ref:"item",refInFor:true,attrs:{"report":report}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }